const Admin = () => {
	return (
		<div>
			<h1>Estamos en Admin...</h1>
		</div>
	);
};

export default Admin;
